import React, { useRef, useState } from 'react';
import { useParams } from 'presentation/hooks';
import { RolledUpSideBar, SideBarRef } from './RolledUpSideBar';
import { SourceContent } from './SourceContent';
import { Container, DocumentPlaceholder } from './SourcePage.styles';
import { useSearchParams } from 'react-router-dom';

export const SourcePage = () => {
  const { id } = useParams<'SOURCE'>();
  const [search] = useSearchParams();

  // Rolled-up number parameters
  const companyId = search.get('company_id') ?? '';
  const period = search.get('period') ?? '';
  const formula = search.get('formula');

  // Stitcher parameters
  const rowNumber = search.get('row_number');
  const periodTag = search.get('period_tag');
  const unitTag = search.get('unit_tag');
  const fundamentalIds = search.getAll('id');

  const innerSideBarRef = useRef<SideBarRef>(null);

  const [fundamentalId, setFundamentalId] = useState<string>(id ?? fundamentalIds.at(-1) ?? '');

  const isRolledUp = Boolean(companyId && period && formula);
  const isStitcher = Boolean(rowNumber && periodTag && unitTag && !!fundamentalIds.length);

  return (
    <Container>
      {isRolledUp && (
        <RolledUpSideBar
          ref={innerSideBarRef}
          selectedFundamental={fundamentalId}
          onFundamentalClick={setFundamentalId}
        />
      )}
      {!!fundamentalId && (
        <SourceContent
          fundamentalId={fundamentalId}
          innerSideBarRef={innerSideBarRef}
          isStitcher={isStitcher}
        />
      )}
      {!fundamentalId && !innerSideBarRef.current?.loading && (
        <DocumentPlaceholder>Select a data point to view its details</DocumentPlaceholder>
      )}
    </Container>
  );
};
